module.exports = __webpack_public_path__ + "static/image-desktop-active-c8b0ec1ad340565b1a59acce151b11be.png";